/**
 * English translations
 */
export const en = {
  // Login Screen
  login: {
    title: "Enter the Game",
    description: "Choose a unique username to identify yourself in the game",
    username: "Username",
    usernamePlaceholder: "Enter your username",
    usernameHelp: "This name will be used to identify you during the game",
    enterButton: "Enter",
    enteringButton: "Entering...",
    error: "Error",
    onlinePlayers: "Online Players",
    activeTables: "Active Tables",
    footer: "© 2025 Guild for Glory",
  },

  // Common
  common: {
    loading: "Loading...",
    error: "Error",
    success: "Success",
    cancel: "Cancel",
    confirm: "Confirm",
    yes: "Yes",
    no: "No",
  },

  // Table
  table: {
    create: "Create Table",
    join: "Join",
    watch: "Watch",
    leave: "Leave",
    start: "Start Game",
    players: "Players",
    maxPlayers: "Max Players",
    status: "Status",
    waiting: "Waiting",
    playing: "Playing",
    inProgress: "In Progress",
    draft: "Draft",
  },

  // Game
  game: {
    title: "Guild for Glory",
    subtitle: "Epic tabletop adventures await!",
  },

  // Header
  header: {
    title: "TableTop",
    activeTables: "Active Tables",
    activeSession: "Active Session",
    online: "Online",
    showOnlinePlayersLabel: "Show online players",
    usingMockData: "Using mock data (WebSocket not connected)",
    livePlayersFromWebSocket: "Live players from WebSocket",
    mockDataOffline: "Mock data (WebSocket offline)",
    noPlayersOnline: "No players online",
    owner: "Owner",
    tables: "table(s)",
    logout: "Log out",
  },
};

/**
 * Portuguese translations
 */
export const pt = {
  // Login Screen
  login: {
    title: "Entrar no Jogo",
    description:
      "Escolha um nome de usuário único para identificar você no jogo",
    username: "Nome de Usuário",
    usernamePlaceholder: "Digite seu nome de usuário",
    usernameHelp: "Este nome será usado para identificar você durante o jogo",
    enterButton: "Entrar",
    enteringButton: "Entrando...",
    error: "Erro",
    onlinePlayers: "Jogadores Online",
    activeTables: "Mesas Ativas",
    footer: "© 2025 Guild for Glory",
  },

  // Common
  common: {
    loading: "Carregando...",
    error: "Erro",
    success: "Sucesso",
    cancel: "Cancelar",
    confirm: "Confirmar",
    yes: "Sim",
    no: "Não",
  },

  // Table
  table: {
    create: "Criar Mesa",
    join: "Entrar",
    watch: "Assistir",
    leave: "Sair",
    start: "Iniciar Jogo",
    players: "Jogadores",
    maxPlayers: "Máx. Jogadores",
    status: "Status",
    waiting: "Aguardando",
    playing: "Jogando",
    inProgress: "Em Andamento",
    draft: "Rascunho",
  },

  // Game
  game: {
    title: "Guild for Glory",
    subtitle: "Aventuras épicas de mesa te aguardam!",
  },

  // Header
  header: {
    title: "TableTop",
    activeTables: "Mesas Ativas",
    activeSession: "Sessão Ativa",
    online: "Online",
    showOnlinePlayersLabel: "Mostrar jogadores online",
    usingMockData: "Usando dados fictícios (WebSocket não conectado)",
    livePlayersFromWebSocket: "Jogadores ao vivo do WebSocket",
    mockDataOffline: "Dados fictícios (WebSocket offline)",
    noPlayersOnline: "Nenhum jogador online",
    owner: "Proprietário",
    tables: "mesa(s)",
    logout: "Sair",
  },
};
